/**  */
export interface IGiftCardDigitalOption {
  action: EGiftCardDigitalMessageAction;
  isSelected?: boolean;
  labelTranslationKey: string;
  classes: string;
}

export enum EGiftCardDigitalMessageAction {
  none,
  message,
  video
}
